import { defineStore } from 'pinia'

export const useCustomerStore = defineStore('customer', {
  state: () => ({
    // Personal details
    firstName: '',
    lastName: '',
    identityDocNo: '',
    email: '',
    title: '',
    gender: '',
    maritalStatus: '',
    dateOfBirth: null,

    // Address
    street: '',
    town: '',
    branch: '',

    // Financial info
    monthlyIncomeAmount: '',
    sourceOfIncome: '',
    lineOfBusiness: '',
    activityExpectedOnAccount: '',

    // Other
    currency: '',
  }),
  getters: {
    fullName: (state) => `${state.firstName} ${state.lastName}`.trim(),
    customerDetails: (state) => ({ ...state }),
  },
  actions: {
    setCustomerDetails(details) {
      if (details.firstName !== undefined) this.firstName = details.firstName
      if (details.lastName !== undefined) this.lastName = details.lastName
      if (details.identityDocNo !== undefined) this.identityDocNo = details.identityDocNo
      if (details.email !== undefined) this.email = details.email
      if (details.title !== undefined) this.title = details.title
      if (details.gender !== undefined) this.gender = details.gender
      if (details.maritalStatus !== undefined) this.maritalStatus = details.maritalStatus
      if (details.dateOfBirth !== undefined) this.dateOfBirth = details.dateOfBirth
      if (details.street !== undefined) this.street = details.street
      if (details.town !== undefined) this.town = details.town
      if (details.branch !== undefined) this.branch = details.branch
      if (details.monthlyIncomeAmount !== undefined) this.monthlyIncomeAmount = details.monthlyIncomeAmount
      if (details.sourceOfIncome !== undefined) this.sourceOfIncome = details.sourceOfIncome
      if (details.lineOfBusiness !== undefined) this.lineOfBusiness = details.lineOfBusiness
      if (details.activityExpectedOnAccount !== undefined) this.activityExpectedOnAccount = details.activityExpectedOnAccount
      if (details.currency !== undefined) this.currency = details.currency
    },
    setPersonalInfo({ firstName, lastName, identityDocNo, email, title, gender, maritalStatus, dateOfBirth }) {
      if (firstName) this.firstName = firstName
      if (lastName) this.lastName = lastName
      if (identityDocNo) this.identityDocNo = identityDocNo
      if (email) this.email = email
      if (title) this.title = title
      if (gender) this.gender = gender
      if (maritalStatus) this.maritalStatus = maritalStatus
      if (dateOfBirth) this.dateOfBirth = dateOfBirth
    },
    setAddress({ street, town, branch }) {
      if (street) this.street = street
      if (town) this.town = town
      if (branch) this.branch = branch
    },
    setFinancialInfo({ monthlyIncomeAmount, sourceOfIncome, lineOfBusiness, activityExpectedOnAccount }) {
      if (monthlyIncomeAmount) this.monthlyIncomeAmount = monthlyIncomeAmount
      if (sourceOfIncome) this.sourceOfIncome = sourceOfIncome
      if (lineOfBusiness) this.lineOfBusiness = lineOfBusiness
      if (activityExpectedOnAccount) this.activityExpectedOnAccount = activityExpectedOnAccount
    },
    setCurrency(currency) {
      this.currency = currency
    },
    clearCustomer() {
      this.$reset()
    },
  },
  persist: true,
})
